import {observer} from 'mobx-react';
import React, {useState, useCallback} from 'react';
import {action} from 'mobx';
import s from '../../s';
import {add_to_cart} from '../../api';
import ATCButtonTemplate from './atc-button-template';

type Props = {
    label?: string;
    buyNow?: boolean;
    additionalClass?: string;
};

const ATCButton: React.FC<Props> = observer(({buyNow, additionalClass}) => {
    const [loading, setLoading] = useState<boolean>(false);

    const atc = useCallback(
        action(async (buyNowParam = false) => {
            setLoading(true);

            if (s.prod.IsCAF && !(s.ps.caf_input_sizes || s.ps.caf_valid_sizes)) {
                s.ui.show_caf_doc_sizes = true;
                setLoading(false);
            } else if (s.prod.allowUpload2 && !s.ui.image_uploaded) {
                s.ui.image_uploaded_msg = `Please upload a ${s.prod.DocType} image before adding to cart`;
                setLoading(false);
            } else if (s.si.StoreID === 205164 && ((s.prod.linos && s.prod.linos.length && (!s.ps.lino_id || !s.ps.lino_text)) || (s.prod.ProductID === 88937 && (!s.ps.custom_text_1 || s.ps.custom_text_1.length < 5)))) {
                s.ps.atc_error = `A selection for ${s.si.ProductLinoSelectionText || 'Embossed Text'} is required.`;
                setLoading(false);
            } else {
                try {
                    await add_to_cart(buyNowParam);
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
        }),
        [],
    );

    return (
        <ATCButtonTemplate
            loading={loading}
            additionalClass={additionalClass}
            clicked={() => atc(buyNow)}
        />
    );
});

export default ATCButton;
